/**
 * KAN-873: одна компактная строка пометок сверху вкладок приложения менеджера
 * (/m): "Уведомления", "Telegram", "Телефон". Каждая ведёт на экран "Начало
 * работы" к своему шагу, действия делаются там. Закрыть строку нельзя.
 * Заменила плашку "Настройка не закончена" (KAN-868) и плашку телефона (KAN-837).
 * Что показывать решает useSetupChips, здесь только отрисовка.
 */
import { Link } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import { useSetupChips } from '@/hooks/useSetupChips';
import { onboardingStepNavState } from '@/lib/managerOnboarding';
import { SETUP_CHIP_LABELS, SETUP_CHIPS_TITLE } from '@/lib/managerSetupChips';
import { MOBILE_START_PATH } from '@/lib/mobileApp';

const CHIP_CLASS =
  'inline-flex h-8 items-center gap-1.5 rounded-full border border-amber-300 bg-white px-3 text-sm font-medium text-amber-800 shadow-sm active:bg-amber-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-400';

export function MobileSetupChips(): JSX.Element | null {
  const chips = useSetupChips();
  if (chips.length === 0) return null;
  return (
    <nav aria-label={SETUP_CHIPS_TITLE} className="px-4 pt-3" data-testid="mobile-setup-chips">
      <ul className="flex flex-wrap gap-2">
        {chips.map((id) => (
          <li key={id}>
            <Link
              to={MOBILE_START_PATH}
              state={onboardingStepNavState(id)}
              className={CHIP_CLASS}
              data-testid={`setup-chip-${id}`}
            >
              <AlertTriangle className="h-4 w-4 shrink-0 text-amber-500" aria-hidden="true" />
              {SETUP_CHIP_LABELS[id]}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}
